import { render } from "./MMDocumentPdf.vue?vue&type=template&id=2dab7ff1"
import script from "./MMDocumentPdf.vue?vue&type=script&lang=js"
export * from "./MMDocumentPdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__